import { Cell, Label, Pie, PieChart, ResponsiveContainer } from 'recharts';
import { GradeBand } from '@peekapak/types/EmotionsClassification';
import { getMoodDisplayName } from '@peekapak/types/Mood';
import { SectionSummary } from './ConcerningEmotionsReportSummary';
import { getEmotionColor } from './ConcerningEmotionsReportUtilities';
import styles from './ConcerningEmotionsReport.module.scss';

interface Props {
  summary: SectionSummary;
  gradeBand: GradeBand;
}

const ConcerningEmotionsReportSummaryWidget = ({ summary, gradeBand }: Props): JSX.Element => {
  const pieData = summary.byFeeling.map(({ feeling, count }) => ({
    name: getMoodDisplayName(feeling),
    value: count,
    color: getEmotionColor(feeling, gradeBand).backgroundColor,
  }));

  return (
    <div className={styles.summaryWidget}>
      <div className={styles.summaryChart}>
        <p className={styles.summaryChartLabel}>Down moods this period</p>
        {/* Pie stays a fixed size; the legend is plain HTML so the box grows
            in normal document flow to fit however many categories there are,
            instead of guessing a pixel height for an SVG legend. */}
        <div className={styles.summaryChartBody}>
          <ResponsiveContainer className={styles.summaryChartPie} width={160} height={160}>
            <PieChart>
              <Pie data={pieData} dataKey='value' nameKey='name' innerRadius={45} outerRadius={70}>
                <Label value={summary.totalDownMoods} position='center' className={styles.summaryChartTotal} />
                {pieData.map((entry) => (
                  <Cell key={entry.name} fill={entry.color} />
                ))}
              </Pie>
            </PieChart>
          </ResponsiveContainer>
          <ul className={styles.summaryLegend}>
            {pieData.map((entry) => (
              <li key={entry.name} className={styles.summaryLegendItem}>
                <span className={styles.summaryLegendSwatch} style={{ backgroundColor: entry.color }} />
                {entry.name} ({entry.value})
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className={styles.summaryCards}>
        {summary.byFeeling.map(({ feeling, count }) => (
          <div key={getMoodDisplayName(feeling)} className={styles.summaryCard}>
            <p className={styles.summaryCardCount}>{count}</p>
            <p className={styles.summaryCardLabel}>{getMoodDisplayName(feeling)}</p>
          </div>
        ))}
        <div className={styles.summaryCard}>
          <p className={styles.summaryCardCount}>{summary.totalDownMoods}</p>
          <p className={styles.summaryCardLabel}>Total down moods</p>
        </div>
      </div>
    </div>
  );
};

export default ConcerningEmotionsReportSummaryWidget;
